// extracted by mini-css-extract-plugin
export default {"container":"M8ne","photo":"WCNN","imgWrapper":"D1Px","btnsWrapper":"jUqF"};